import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DnPrimaryBtnModule } from './components/dn-primary-btn/dn-primary-btn.module';
import { DnPersonImageModule } from './components/dn-person-image/dn-person-image.module';
import { DnCheckboxModule } from './components/dn-checkbox/dn-checkbox.module';
import { FormInputModule } from './components/dn-form-input/form-input.module';
import { ValidationService } from './service/validation/validation.service';
import { DnDialogsModule } from './components/dialogs/dn-dialogs.module';
import { DnBtnModule } from './components/buttons/dn-btn/dn-btn.module';
import { DnGhostBtnModule } from './components/buttons/dn-ghost-btn/dn-ghost-btn.module';
import { DnSocialBtnModule } from './components/buttons/dn-social-btn/dn-social-btn.module';
import { DnHeaderBtnModule } from './components/buttons/dn-header-btn/dn-header-btn.module';
import { DnIconAndTextModule } from './components/dn-icon-and-text/dn-icon-and-text.module';
import { DnShowHideModule } from './components/dn-show-hide/dn-show-hide.module';
import { DnTooltipModule } from './components/directives/dn-tooltip/dn-tooltip.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DnNotyModule } from './components/noty-components/dn-noty.module';
import { BillingAddressModule } from './components/billing-address/billing-address.module';
import { CopyToClipboardModule } from './components/copy-to-clipboard/copy-to-clipboard.module';
import { DnNeverbounceValidationModule } from './components/dn-neverbounce-validation/dn-neverbounce-validation.module';
import { DnSecondaryBtnModule } from './components/dn-secondary-btn/dn-secondary-btn.module';
import { MenuInputModule } from './components/menu-input/menu-input.module';
import { CookieConsentModule } from './components/cookie-conset/cookie-consent.module';
import { DnMarktingBtnModule } from './components/buttons/dn-markting-btn/dn-markting-btn.module';
import { HttpClient } from '@angular/common/http';
import { DnTableModule } from './components/dn-table/dn-table.module';
import { PaginationModule } from './components/pagination/pagination.module';
import { SkeletonModule } from './components/skeleton/skeleton.module';
import { EnterPressModule } from './components/directives/enter-press/enter-press.module';
import { DnAnimationModule } from './components/directives/dn-animation/dn-animation.module';
import { DnToggleModule } from './components/dn-toggle/dn-toggle.module';
import { DnCustomBtnModule } from './components/dn-custom-btn/dn-custom-btn.module';
import { DnCountdownModule } from './components/dn-countdown/dn-countdown.module';
import { DnCoinModule } from './components/dn-coin/dn-coin.module';

const MODULES = [
  DnPrimaryBtnModule,
  DnSecondaryBtnModule,
  DnPersonImageModule,
  DnCheckboxModule,
  FormInputModule,
  DnBtnModule,
  DnGhostBtnModule,
  DnSocialBtnModule,
  DnHeaderBtnModule,
  DnIconAndTextModule,
  DnShowHideModule,
  DnDialogsModule,
  DnTooltipModule,
  DnAnimationModule,
  MatSnackBarModule,
  DnNotyModule,
  BillingAddressModule,
  CopyToClipboardModule,
  DnNeverbounceValidationModule,
  MenuInputModule,
  CookieConsentModule,
  DnMarktingBtnModule,
  DnTableModule,
  PaginationModule,
  SkeletonModule,
  EnterPressModule,
  DnToggleModule,
  DnCountdownModule,
  DnCoinModule,
  DnCustomBtnModule,
];

@NgModule({
  declarations: [],
  providers: [ValidationService, HttpClient],
  imports: [CommonModule, ...MODULES],
  exports: [...MODULES],
})
export class DatanyzeCommonModule {}
